export default __webpack_public_path__ + "static/media/Portrait.c96a7bd8.jpg";